"use client";
import { n as e } from "./neonSlam-Bv1P_HLg.js";
import { n as t } from "./neonPack-bmhqbOUW.js";
import { t as n } from "./retailBox-J9FR2_9d.js";
//#region src/allOpeners.ts
function r() {
	e(), t(), n();
}
//#endregion
export { r as registerAllOpeners };

//# sourceMappingURL=openers.js.map